export default __webpack_public_path__ + "static/media/pedro-pascal.29a87a8c.jpg";